import {
  getIsFullstoryAiWeddingPlannerSampled,
  useABTest_FullstoryAiWeddingPlanner,
} from '@bridebook/web/lib/ab-tests/tests/LIVE-29320_FullstoryAiWeddingPlanner';
import { getVariant_AiWeddingPlanner } from '@bridebook/web/lib/ab-tests/tests/global/LIVE-28398_AiWeddingPlanner';
import { isAiWeddingPlannerVariantEnabled } from '@bridebook/web/lib/ai-planner/availability';
import { useFullStory, useFullStoryUserProperties } from '@bridebook/web/lib/hooks/use-fullstory';
import { useSelector } from '@bridebook/web/lib/utils';

/**
 * Records a sample of the couples in a planner cohort with FullStory, on every page and
 * not only with the planner open, so a session shows the journey around the planner too.
 * The sample is its own A/B test, so recording stays within the plan quota as cohorts grow.
 * Control and markets without the planner keep only the existing FullStory coverage.
 * The planner variant is stored on the user, so planner sessions can be found and compared.
 */
export const usePlannerFullStory = () => {
  useABTest_FullstoryAiWeddingPlanner();
  const variant = useSelector(getVariant_AiWeddingPlanner);
  const sampled = useSelector(getIsFullstoryAiWeddingPlannerSampled);
  const enabled = isAiWeddingPlannerVariantEnabled(variant) && sampled;

  useFullStory(enabled);
  useFullStoryUserProperties(enabled, { aiWeddingPlannerVariant: variant });
};
